/* eslint-disable */
import 'jquery';
import 'jquery.scrollto';

const skip_to_content = (function() {
  
  // Setup interactive handlers
  const init = () => {
    $('.skip-to-content').on('click', function(e) { 
      e.preventDefault();
      $(window).scrollTo('#main-content', {
        duration: 500,
        onAfter: function() {
          $('.skip-to-content').blur();
          $('#main-content').focus();
        }
      });
    });
  };

  return {
    init: init,
  }
})();

$(document).ready(function() {
  skip_to_content.init();
});
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/components/skip_to_content.js